import z from "zod";

import { LOGIN_FAILURE_CODES, type LoginCredentials } from "./auth.types";

export const loginCredentialsSchema: z.ZodType<LoginCredentials> = z.object({
  // Trimmed before the format check so that a pasted " name@cabinet.fr " is accepted.
  email: z
    .string()
    .trim()
    .min(1, { message: LOGIN_FAILURE_CODES.EMPTY_EMAIL })
    .pipe(z.email({ message: LOGIN_FAILURE_CODES.INVALID_EMAIL })),
  password: z.string().min(1, { message: LOGIN_FAILURE_CODES.EMPTY_PASSWORD }),
});
